module.exports = __webpack_public_path__ + "img/19.345465c9.jpg";